//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export enum ManualUserSyncJobState {
  Enqueued = 0,
  Processing = 1,
  Succeeded = 2,
  Failed = 3,
  Skipped = 4
}
